// This is dumb, we should migrate to storing first and last names explicitly
// in the database
export function formatCaregiverName(
    fullName: string,
    displayLastFirst: boolean,
): string {
    const trimmed = fullName.trim();
    if (!displayLastFirst || trimmed.length === 0) {
        return trimmed;
    }

    // If the name already contains a comma, assume it is pre-formatted.
    if (trimmed.includes(',')) {
        return trimmed;
    }

    const parts = trimmed.split(/\s+/);
    if (parts.length === 1) {
        return trimmed;
    }

    const [first, ...rest] = parts;
    const last = rest.join(' ');
    return `${last}, ${first}`;
}

export function compareCaregiverDisplayName(
    nameA: string,
    nameB: string,
    formatName: (s: string) => string,
    sortByLastName = false,
): number {
    const displayA = (
        sortByLastName ? formatCaregiverName(nameA, true) : formatName(nameA)
    ).toLocaleLowerCase();
    const displayB = (
        sortByLastName ? formatCaregiverName(nameB, true) : formatName(nameB)
    ).toLocaleLowerCase();
    if (displayA < displayB) {
        return -1;
    }
    if (displayA > displayB) {
        return 1;
    }
    return 0;
}

export function comparePersonNames(
    nameA: string,
    nameB: string,
    sortByLastName: boolean,
): number {
    const sortNameA = sortByLastName
        ? formatCaregiverName(nameA, true)
        : nameA.trim();
    const sortNameB = sortByLastName
        ? formatCaregiverName(nameB, true)
        : nameB.trim();
    return sortNameA.localeCompare(sortNameB, undefined, {
        sensitivity: 'base',
    });
}
